import type { Plan } from '../types/user';

export type BillingInterval = 'monthly' | 'yearly';

export interface PlanLimits {
  maxMonitoraggi: number;
  aiAnalysis: boolean;
  alertPredittivo: boolean;
  voiceAssistant: boolean;
  voiceSearchesPerMonth: number;
}

export const PLAN_LIMITS: Record<Plan, PlanLimits> = {
  free: { maxMonitoraggi: 1, aiAnalysis: false, alertPredittivo: false, voiceAssistant: false, voiceSearchesPerMonth: 0 },
  // Pro: 5 sentinelle, AI search, alert predittivi, no voce
  premium: { maxMonitoraggi: 5, aiAnalysis: true, alertPredittivo: true, voiceAssistant: false, voiceSearchesPerMonth: 0 },
  // Unlimited: sentinelle illimitate, tutto incluso, 10 ricerche vocali/mese
  unlimited: { maxMonitoraggi: 999, aiAnalysis: true, alertPredittivo: true, voiceAssistant: true, voiceSearchesPerMonth: 10 },
} as const;

/** Display names for plans (used in UI) */
export const PLAN_DISPLAY_NAMES: Record<Plan, string> = {
  free: 'Free',
  premium: 'Pro',
  unlimited: 'Unlimited',
} as const;

export interface PlanPrice {
  monthly: number;
  yearly: number;
  currency: string;
}

export const PLAN_PRICES: Record<Exclude<Plan, 'free'>, PlanPrice> = {
  premium: { monthly: 0.99, yearly: 8.99, currency: 'EUR' },
  unlimited: { monthly: 4.99, yearly: 44.99, currency: 'EUR' },
} as const;

/** Ordered list of plans from lowest to highest tier */
export const PLAN_ORDER: readonly Plan[] = ['free', 'premium', 'unlimited'] as const;

/**
 * Check if a user can add more monitoraggi based on their plan.
 */
export function canAddMonitoraggio(plan: Plan, currentCount: number): boolean {
  return currentCount < PLAN_LIMITS[plan].maxMonitoraggi;
}

/**
 * Check if upgrading from one plan to another is an upgrade (not downgrade).
 */
export function isUpgrade(from: Plan, to: Plan): boolean {
  return PLAN_ORDER.indexOf(to) > PLAN_ORDER.indexOf(from);
}
